import { normalize, schema } from 'normalizr';

export const entity = 'settlement';
export const entitySchema = new schema.Entity(entity);
export const normalizer = (result) => normalize(result[0], entitySchema);
